var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.Loading)?_c('v-progress-linear'):_vm._e(),(_vm.contract)?_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.contract.Title)+" ")]),_c('v-card-text',{staticClass:"pa-4 poppins-regular",domProps:{"innerHTML":_vm._s(_vm.contract.ContractText)}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }